import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from 'dayjs'

const exportToExcel = (data, hours, amount, turf) => {
    const month = dayjs(data[0].date).format('MMMM')
    const flatData = data.flatMap((item) =>
        {
            item.bookings =  item.bookings || [];
            return item.bookings.map((booking) => ({
                Date: item.date,
                "Booking From": dayjs(booking.from).format('HH:mm'),
                "Booking To": dayjs(booking.to).format('HH:mm'),
                "Tenant Name": booking.tenant.name,
                "Tenant Contact": booking.tenant.contactNumber,
                Amount: booking.amount,
                "Total Hours": booking.totalHours,
                Advance: booking.advance,
                Discount: booking.discount,
            }))
        }
    );
    flatData.push({})
    
    flatData.push({
        Date: "Total",
        "Booking From": "",
        "Booking To": "",
        "Tenant Name": "",
        "Tenant Contact": "",
        Amount: amount, // Total sum of Amount column
        "Total Hours": hours, // Total sum of Total Hours column        
        Advance: "",
        Discount: "",
      });
      const totalRowIndex = flatData.length
  // Create a new worksheet
  const worksheet = XLSX.utils.json_to_sheet(flatData);

  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: col });
    const headerAddress =  XLSX.utils.encode_cell({ r: 0, c: col });
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = { font: { bold: true } }; // Apply bold style
    }
    if (worksheet[headerAddress]) {
        worksheet[headerAddress].s = { font: { bold: true } }; // Apply bold style
      }
  }

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

  // Generate an Excel file and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(file, `${turf}_${month}_booking_report.xlsx`);
}

export {exportToExcel}